import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

const calcDate = (currentDate, days) => moment(currentDate).add(days, 'day').utc().format();

const TinyDateField = ({ className, onCancel, onSubmit, onChange }) => {
  const ref = useRef(null);
  const [currentDate, setCurrentDate] = useState(moment().utc().format());

  const onKeyUp = (e) => {
    const { key } = e;
    if (key === 'ArrowUp') {
      increaseDay();
    }
    if (key === 'ArrowDown') {
      decreaseDay();
    }
    if (key === 'Escape') {
      onCancel();
    }
    if (key === 'Enter') {
      onSubmit(e);
    }
  };

  const increaseDay = () => {
    setCurrentDate(calcDate(currentDate, 1));
  };

  const decreaseDay = () => {
    setCurrentDate(calcDate(currentDate, -1));
  };

  const onUpClick = () => {
    ref.current.focus();
    increaseDay();
  };

  const onDownClick = () => {
    ref.current.focus();
    decreaseDay();
  };

  useEffect(() => {
    onChange(currentDate);
  }, [onChange, currentDate]);

  const formattedValue = moment(currentDate).format('DD MMM');

  return (
    <div className={className} data-testid="tiny-date-field">
      <input
        ref={ref}
        className={className}
        value={formattedValue}
        onKeyUp={onKeyUp}
        data-testid="tiny-date-field__input"
      />
      <span
        className="tiny-date-field__arrow up"
        onClick={onUpClick}
        data-testid="tiny-date-field__up"
      />
      <span
        className="tiny-date-field__arrow down"
        onClick={onDownClick}
        data-testid="tiny-date-field__down"
      />
    </div>
  );
};

TinyDateField.propTypes = {
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  onChange: PropTypes.func,
};

export default TinyDateField;
